module.exports = __webpack_public_path__ + "static/media/sel_group_l.63912b88.svg";